import { render, staticRenderFns } from "./PersonRegistrationCandidateSearchField.vue?vue&type=template&id=7cb74632&scoped=true"
import script from "./PersonRegistrationCandidateSearchField.vue?vue&type=script&lang=ts"
export * from "./PersonRegistrationCandidateSearchField.vue?vue&type=script&lang=ts"
import style0 from "./PersonRegistrationCandidateSearchField.vue?vue&type=style&index=0&id=7cb74632&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb74632",
  null
  
)

export default component.exports